/**
 * Shared App Bridge detection + wait (single poll implementation).
 * Used by AppBridgeReadyProvider and useAuthenticatedFetch embeddedFetch.
 */

const APP_BRIDGE_POLL_MS = 200
const APP_BRIDGE_MAX_WAIT_MS = 10000

export function appBridgeHasSessionToken(): boolean {
  return typeof window !== 'undefined' && typeof window.shopify?.idToken === 'function'
}

/** Resolves when idToken is callable, or rejects after APP_BRIDGE_MAX_WAIT_MS. */
export function waitForAppBridge(): Promise<void> {
  if (appBridgeHasSessionToken()) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const id = setInterval(() => {
      if (appBridgeHasSessionToken()) {
        clearInterval(id)
        resolve()
      } else if (Date.now() - start > APP_BRIDGE_MAX_WAIT_MS) {
        clearInterval(id)
        reject(new Error('App Bridge did not initialize in time'))
      }
    }, APP_BRIDGE_POLL_MS)
  })
}
